export const AGENT_REPORT_COLUMNS = [
  'agent_time',
  'agent_sessions',
  'agent_tokens',
  'agent_cost',
  'agent_periods',
  'agent_input_tokens',
  'agent_output_tokens',
  'agent_cache_read_tokens',
  'agent_cache_write_tokens',
] as const;
export type AgentReportColumn = (typeof AGENT_REPORT_COLUMNS)[number];
export const AGENT_REPORT_LABELS: Record<AgentReportColumn, string> = {
  agent_time: 'Agent time',
  agent_sessions: 'Agent sessions',
  agent_tokens: 'Tokens used',
  agent_cost: 'Estimated agent cost · USD',
  agent_periods: 'Activity periods',
  agent_input_tokens: 'Input tokens',
  agent_output_tokens: 'Output tokens',
  agent_cache_read_tokens: 'Cache-read tokens',
  agent_cache_write_tokens: 'Cache-write tokens',
};
export type AgentReportMetrics = Record<AgentReportColumn, number | null> & {
  missing_periods?: Partial<Record<AgentReportColumn, number>>;
  unknown_metric_periods: number;
  unknown_cost_periods: number;
  currency: string;
  pricing_version: string;
  filters?: Record<string, string>;
};
export const isAgentReportColumn = (column: string): column is AgentReportColumn =>
  (AGENT_REPORT_COLUMNS as readonly string[]).includes(column);

export const isAgentOnlyWidget = (columns: readonly string[]) =>
  columns.some(isAgentReportColumn) &&
  columns.every(column => column === 'name' || isAgentReportColumn(column));

export function missingAgentMetricPeriods(
  metrics: AgentReportMetrics | undefined,
  column: AgentReportColumn
): number {
  if (metrics?.missing_periods) return metrics.missing_periods[column] ?? 0;
  if (column === 'agent_sessions' || column === 'agent_periods') return 0;
  return (
    (column === 'agent_cost' ? metrics?.unknown_cost_periods : metrics?.unknown_metric_periods) ?? 0
  );
}
